// extracted by mini-css-extract-plugin
module.exports = {"modal":"introview_modal__2mesL","innerContainer":"introview_innerContainer__12yFn","logo":"introview_logo__2o4Zr","introCopy":"introview_introCopy__RQDlQ"};